var $ = require( "jquery" );
require('fslightbox');

import { Splide } from '@splidejs/splide';
import { Fancybox } from "@fancyapps/ui";
import { Grid } from '@splidejs/splide-extension-grid';


document.addEventListener('DOMContentLoaded', function() {
    var buttonShare = document.getElementById('button-share');
    var dropMenu = document.getElementById('drop-menu');

    if (buttonShare && dropMenu) {
        buttonShare.addEventListener('click', function() {
            if (dropMenu.style.display === 'none' || dropMenu.style.display === '') {
                dropMenu.style.display = 'block';
            } else {
                dropMenu.style.display = 'none';
            }
        });
    }
});




document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.getElementById('carousel');
  if (carousel !== null && carousel !== undefined) {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var splide = new Splide(carousel, {
      type         : 'loop',
      autoplay     : !prefersReduced,
      interval     : 4500,
      pauseOnHover : true,
      pauseOnFocus : true,
      arrows       : false,
      resetProgress: false,
      drag         : true,
      i18n: {
        prev: 'Slide precedente',
        next: 'Slide successiva',
        slide: 'Slide',
        slideX: 'Vai alla slide %s',
        select: 'Seleziona una slide',
        pause: 'Metti in pausa lo slider',
        play: 'Avvia lo slider',
        first: 'Prima slide',
        last: 'Ultima slide'
      }
    });
    splide.mount();

    // Pulsante pause/play accessibile (WCAG 2.2.2)
    var pauseBtn = document.createElement('button');
    pauseBtn.type = 'button';
    pauseBtn.className = 'carousel__pause';
    pauseBtn.setAttribute('aria-pressed', prefersReduced ? 'true' : 'false');
    pauseBtn.setAttribute('aria-label', prefersReduced ? 'Avvia lo slider' : 'Metti in pausa lo slider');
    pauseBtn.innerHTML = '<span aria-hidden="true">' + (prefersReduced ? '&#9654;' : '&#10073;&#10073;') + '</span>';
    carousel.appendChild(pauseBtn);

    pauseBtn.addEventListener('click', function () {
      var isPaused = pauseBtn.getAttribute('aria-pressed') === 'true';
      if (isPaused) {
        splide.Components.Autoplay.play();
        pauseBtn.setAttribute('aria-pressed', 'false');
        pauseBtn.setAttribute('aria-label', 'Metti in pausa lo slider');
        pauseBtn.querySelector('[aria-hidden]').innerHTML = '&#10073;&#10073;';
      } else {
        splide.Components.Autoplay.pause();
        pauseBtn.setAttribute('aria-pressed', 'true');
        pauseBtn.setAttribute('aria-label', 'Avvia lo slider');
        pauseBtn.querySelector('[aria-hidden]').innerHTML = '&#9654;';
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  var nextEvent = document.getElementById('nextEvent');
  if (nextEvent !== null && nextEvent !== undefined) {
    new Splide(nextEvent, {
      arrows: false,
      type: 'slide',
      autoplay: false,
      interval: 15000,
      pauseOnHover: false,
      resetProgress: false,
      drag: true,
      breakpoints: {
        780: {
          grid: {
        rows: 1,
        cols: 2,
        gap: {
          row: '1rem',
          col: '1.5rem',
        },
      },
        },

                620: {
          grid: {
        rows: 1,
        cols: 1,
        gap: {
          row: '1rem',
          col: '1.5rem',
        },
      },
        },
      },
      grid: {
        rows: 1,
        cols: 3,
        gap: {
          row: '1rem',
          col: '1.5rem',
        },
      },
      classes: {
		pagination: 'splide__pagination pagination__nextEvent',
		page      : 'splide__pagination__page pagination__nextEvent-page',
  },
    }).mount({ Grid });
  }
});







Fancybox.bind('[data-fancybox="gallery"]', {
  Thumbs: {
    Carousel: {
      fill: false,
      center: true,
    },
  },
});






// Menu principale accessibile: gestione toggle sottomenu via <button> (walker custom)
(function () {
  var mainNav = document.querySelector('.main-nav');
  if (!mainNav) return;

  // Reset eventuali inline style residui su sottomenu (impedisce override della CSS)
  mainNav.querySelectorAll('ul').forEach(function (ul) {
    ul.style.display = '';
  });

  var toggles = mainNav.querySelectorAll('.main-nav__toggle');

  function closeAll(except) {
    toggles.forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      closeAll(btn);
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!mainNav.contains(e.target)) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Trova toggle aperto che contiene il focus corrente (o qualsiasi aperto)
    var openToggle = null;
    toggles.forEach(function (btn) {
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      var parentLi = btn.closest('li');
      if (parentLi && parentLi.contains(document.activeElement)) {
        openToggle = btn;
      } else if (!openToggle) {
        openToggle = btn;
      }
    });
    closeAll(null);
    if (openToggle) openToggle.focus();
  });

  // Sub-toggle (depth >= 1): button per voci nested con figli
  var subToggles = mainNav.querySelectorAll('.main-nav__sub-toggle');

  function closeSubSiblings(except) {
    subToggles.forEach(function (btn) {
      if (btn === except) return;
      // chiudi solo se è sibling dello stesso parent ul
      if (except && btn.parentElement.parentElement !== except.parentElement.parentElement) return;
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAllSub() {
    subToggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  subToggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      closeSubSiblings(btn);
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) return; // lascia propagare al document handler per chiudere il parent
      e.stopPropagation();
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    });
  });

  // ESC su elementi interni al sub-menu: risali fino al primo sub-toggle antenato aperto
  mainNav.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.activeElement;
    if (!active) return;
    var startLi = active.closest('li');
    // se focus è già su un sub-toggle, parti dal li ANTENATO (non da sé)
    if (active.classList.contains('main-nav__sub-toggle') && startLi) {
      startLi = startLi.parentElement && startLi.parentElement.closest('li');
    }
    var li = startLi;
    while (li) {
      var parentBtn = li.querySelector(':scope > .main-nav__sub-toggle[aria-expanded="true"]');
      if (parentBtn) {
        e.stopPropagation();
        parentBtn.setAttribute('aria-expanded', 'false');
        parentBtn.focus();
        return;
      }
      li = li.parentElement && li.parentElement.closest('li');
    }
    // nessun sub-toggle aperto: lascia che document handler chiuda il top-level toggle
  });
})();









(function ($) {
  $(function () {
    $('.topnav__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      e.stopPropagation();
    });
    $('html').on('click', function () {
      $('.topnav__item .sub-menu, .footer-nav-vertical__item .sub-menu, .footer-nav-horizontal__item .sub-menu').hide();
    });
  });
})(jQuery);

// Mobile sub-menu: button con aria-expanded apre/chiude tramite CSS.
// Keyboard nativo (Enter/Space). ESC chiude e ridà focus al toggle padre.
(function () {
  var mobileNav = document.getElementById('main-nav__mobile');
  if (!mobileNav) return;

  var mobileToggles = mobileNav.querySelectorAll('.main-nav__mobile-toggle');

  mobileToggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) return; // lascia propagare per chiudere parent o burger menu
      e.stopPropagation();
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    });
  });

  // ESC: risali fino al primo mobile-toggle antenato aperto
  mobileNav.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.activeElement;
    if (!active) return;
    var startLi = active.closest('li');
    // se focus è già su un mobile-toggle, parti dal li ANTENATO
    if (active.classList.contains('main-nav__mobile-toggle') && startLi) {
      startLi = startLi.parentElement && startLi.parentElement.closest('li');
    }
    var li = startLi;
    while (li) {
      var parentBtn = li.querySelector(':scope > .main-nav__mobile-toggle[aria-expanded="true"]');
      if (parentBtn) {
        e.stopPropagation();
        parentBtn.setAttribute('aria-expanded', 'false');
        parentBtn.focus();
        return;
      }
      li = li.parentElement && li.parentElement.closest('li');
    }
    // nessun mobile-toggle aperto: lascia che burger handler chiuda il menu
  });
})();

(function ($) {
  $(function () {
    $('.footer-nav-vertical__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      e.stopPropagation();
    });
  });
})(jQuery);

(function ($) {
  $(function () {
    $('.footer-nav-horizontal__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      e.stopPropagation();
    });
  });
})(jQuery);



// Burger menu mobile accessibile con focus management
(function () {
  var burger = document.getElementById('header__burger-menu');
  var mobileNav = document.getElementById('main-nav__mobile');
  var burgerIcon = document.getElementById('header__burger-icon');
  if (!burger || !mobileNav) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusable() {
    // Rende focusabili anche gli <a> senza href del menu mobile (item padre senza URL)
    Array.prototype.forEach.call(mobileNav.querySelectorAll('.main-nav__mobile-item > a:not([href]), .main-nav__mobile-item > a[href=""]'), function (a) {
      if (!a.hasAttribute('tabindex')) a.setAttribute('tabindex', '0');
      if (!a.hasAttribute('role')) a.setAttribute('role', 'button');
    });
    return Array.prototype.slice.call(mobileNav.querySelectorAll(FOCUSABLE))
      .filter(function (el) {
        return el.offsetParent !== null;
      });
  }

  function openMobile() {
    mobileNav.classList.add('main-nav__mobile-active');
    mobileNav.removeAttribute('hidden');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Chiudi menu');
    if (burgerIcon) burgerIcon.classList.add('header__nav-icon-active');

    getFocusable();
    setTimeout(function () {
      var firstNav = mobileNav.querySelector('nav, ul');
      var firstLink = firstNav ? firstNav.querySelector('a, button:not(#header__burger-menu), [tabindex]:not([tabindex="-1"])') : null;
      if (firstLink) firstLink.focus();
    }, 0);
  }

  function closeMobile(returnFocus) {
    mobileNav.classList.remove('main-nav__mobile-active');
    mobileNav.setAttribute('hidden', '');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Apri menu');
    if (burgerIcon) burgerIcon.classList.remove('header__nav-icon-active');
    if (returnFocus) burger.focus();
  }

  burger.addEventListener('click', function (e) {
    e.stopPropagation();
    var expanded = burger.getAttribute('aria-expanded') === 'true';
    if (expanded) closeMobile(false);
    else openMobile();
  });

  // Focus trap: Tab ciclico dentro burger + menu
  document.addEventListener('keydown', function (e) {
    if (burger.getAttribute('aria-expanded') !== 'true') return;

    if (e.key === 'Escape') {
      closeMobile(true);
      return;
    }

    if (e.key !== 'Tab') return;

    var focusables = getFocusable();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || active === burger) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (active === last) {
        e.preventDefault();
        burger.focus();
      } else if (active === burger) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('click', function (e) {
    if (burger.getAttribute('aria-expanded') !== 'true') return;
    if (!mobileNav.contains(e.target) && !burger.contains(e.target)) {
      closeMobile(false);
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1400 && burger.getAttribute('aria-expanded') === 'true') {
      closeMobile(false);
    }
  });
})();

/* Legacy burger handler rimosso (sostituito dall'IIFE accessibile sopra)
var __irpet_disabled_burger = function () {





  if (document.getElementById("main-nav__mobile").classList.contains("main-nav__mobile-active")) {

    document.getElementById("main-nav__mobile").classList.remove("main-nav__mobile-active");
    document.getElementById("header__burger-icon").classList.remove("header__nav-icon-active");
  } else {
    document.getElementById("main-nav__mobile").classList.add("main-nav__mobile-active");

    document.getElementById("header__burger-icon").classList.add("header__nav-icon-active");

    window.onclick = (e) => {
      if (!e.target.matches('.main-nav__mobile-container ') && !e.target.matches('.menu-menu-principale-container ') && !e.target.matches('.main-nav__mobile-item ') && !e.target.matches('.main-nav__mobile-content ') && !e.target.matches('.header__burger-menu ') && !e.target.matches('.header__nav-icon ') && !e.target.matches('.header__nav-label ')) {
        
        document.getElementById("main-nav__mobile").classList.remove("main-nav__mobile-active");
        document.getElementById("header__burger-icon").classList.remove("header__nav-icon-active");
       } else {

       }
     }

  }

});
*/


/* ==========================================
scrollTop() >= 300
Should be equal the the height of the header
========================================== */



$(window).on('scroll', function() {
  var header = $('#header');
  var headerHeight = header.outerHeight();

  if ($(window).scrollTop() >= 400 && !header.hasClass('header__fixed') && headerHeight > 0) {
    header.addClass('header__fixed');
    $('body').css('padding-top', headerHeight);
  } else if ($(window).scrollTop() < 400 && header.hasClass('header__fixed')) {
    header.removeClass('header__fixed');
    $('body').css('padding-top', 0);
  }
});


/* ==========================================
dropdown single page
========================================== */
if (document.getElementById("button-share")) {
const buttonShare = document.getElementById('button-share');
const dropMenus = document.getElementById('drop-menu');


buttonShare.addEventListener('click', function () {
    dropMenus.classList.toggle('drop-menu--active');

  })



window.onclick = (e) => {
  if (!e.target.matches('.button-share')) {
    dropMenus.classList.remove('drop-menu--active');
}
}

}

if (document.getElementById("button-share-event")) {
  const buttonShare = document.getElementById('button-share-event');
  const dropMenus = document.getElementById('drop-menu-event');


  buttonShare.addEventListener('click', function () {
    dropMenus.classList.toggle('drop-menu--active');

  })



  window.onclick = (e) => {
    if (!e.target.matches('.button-share')) {
      dropMenus.classList.remove('drop-menu--active');
    }
  }

}


// Legacy handler rimosso: gestione chiusura altri submenu ora in IIFE accessibile sopra (closeAll)





// selezionare tutti gli elementi "li" nell'elenco con id "nav_sezioni_persone"
var listaElementi = document.querySelectorAll('#nav_sezioni_persone li');

// selezionare tutte le sezioni da osservare
var sezioni = document.querySelectorAll('#msa_persone_sezioni section');

// creare un observer
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      // rimuovere la classe "current_page_item" da tutti gli elementi "li"
      listaElementi.forEach(function(elemento) {
        elemento.classList.remove('current_page_item');
      });
      // trovare l'elemento "a" corrispondente alla sezione in vista e aggiungere la classe "current_page_item" al suo genitore "li"
      var aCorrispondente = document.querySelector('a[href="#' + entry.target.id + '"]');
      if (aCorrispondente) {
        var liCorrispondente = aCorrispondente.parentNode;
        liCorrispondente.classList.add('current_page_item');
      }
    }
  });
}, { threshold: 0.5 });

// osservare ciascuna sezione
sezioni.forEach(function(sezione) {
  observer.observe(sezione);
});

// Gestire il click sulle voci di menu
listaElementi.forEach(function(elemento) {
  elemento.addEventListener('click', function(e) {
    e.preventDefault();
    var href = this.querySelector('a').getAttribute('href');
    var sezioneCorrispondente = document.querySelector(href);
    if (sezioneCorrispondente) {
      sezioneCorrispondente.scrollIntoView({ behavior: 'smooth' });
    }
  });
});



// Tabs accessibili (WAI-ARIA Tabs pattern)
(function () {
  var wrappers = document.querySelectorAll('.tab-horinzontal__btn-wrapper');
  wrappers.forEach(function (wrapper) {
    var tabs = Array.from(wrapper.querySelectorAll('[data-tab]'));
    if (!tabs.length) return;

    wrapper.setAttribute('role', 'tablist');
    wrapper.setAttribute('aria-label', 'Pubblicazioni');

    var panels = tabs.map(function (tab) {
      return document.querySelector(tab.dataset.tab);
    }).filter(Boolean);

    tabs.forEach(function (tab, i) {
      var panel = panels[i];
      var isActive = tab.classList.contains('active');
      var tabId = tab.id || 'tab-' + (panel.id || i);
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('aria-controls', panel.id);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');
        if (!isActive) panel.setAttribute('hidden', '');
      }
    });

    function activate(tab) {
      tabs.forEach(function (t, i) {
        var selected = t === tab;
        t.classList.toggle('active', selected);
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
        var panel = panels[i];
        if (panel) {
          panel.classList.toggle('active', selected);
          if (selected) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab);
        tab.focus();
      });
      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab);
        var next;
        switch (e.key) {
          case 'ArrowRight': next = tabs[(idx + 1) % tabs.length]; break;
          case 'ArrowLeft':  next = tabs[(idx - 1 + tabs.length) % tabs.length]; break;
          case 'Home':       next = tabs[0]; break;
          case 'End':        next = tabs[tabs.length - 1]; break;
          default: return;
        }
        e.preventDefault();
        next.focus();
        activate(next);
      });
    });
  });
})();





document.addEventListener('DOMContentLoaded', function() {
    var buttonFilter = document.getElementById('button-filter');
    var filterContainer = document.getElementById('filter-container-extra') || document.getElementById('filter-container');

    if (buttonFilter && filterContainer) {
        if (!filterContainer.hasAttribute('hidden') && !filterContainer.classList.contains('filter-show')) {
            filterContainer.setAttribute('hidden', '');
        }
        buttonFilter.addEventListener('click', function() {
            var expanded = buttonFilter.getAttribute('aria-expanded') === 'true';
            buttonFilter.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            filterContainer.classList.toggle('filter-show');
            if (expanded) {
                filterContainer.setAttribute('hidden', '');
            } else {
                filterContainer.removeAttribute('hidden');
            }
        });
    }
});

// WPML lang selector: riempie lang/hreflang vuoti sul toggle della lingua corrente
// (il plugin emette lang="" causando violazione WCAG 3.1.2).
function fixWpmlLangToggle() {
    document.querySelectorAll('.js-wpml-ls-item-toggle').forEach(function (a) {
        var currentLang = (a.getAttribute('lang') || '').trim();
        if (currentLang) return;
        var li = a.closest('[class*="wpml-ls-item-"]');
        var code = '';
        if (li) {
            var match = li.className.match(/wpml-ls-item-([a-z]{2}(?:-[a-zA-Z]{2,4})?)(?:\s|$)/);
            if (match) code = match[1];
        }
        if (!code) {
            var htmlLang = document.documentElement.getAttribute('lang');
            if (htmlLang) code = htmlLang.split('-')[0];
        }
        if (code) {
            a.setAttribute('lang', code);
            a.setAttribute('hreflang', code);
        }
    });
}

document.addEventListener('DOMContentLoaded', fixWpmlLangToggle);

// Accessibilità FacetWP: rende focusabili/attivabili da tastiera i facet cliccabili
// renderizzati come <div> (tipicamente .facetwp-radio, .facetwp-checkbox, .facetwp-link).
function enhanceFacetWPAccessibility() {
    var selectors = [
        '.facetwp-radio',
        '.facetwp-checkbox',
        '.facetwp-link',
        '.facetwp-selection-value',
        '.facetwp-toggle'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
        if (el.dataset.a11yEnhanced === 'true') return;
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
        var checked = el.classList.contains('checked');
        el.setAttribute('aria-pressed', checked ? 'true' : 'false');
        el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                el.click();
            }
        });
        el.dataset.a11yEnhanced = 'true';
    });

    // Facet di tipo search: aggiunge id + aria-label coerente con il <label> associato
    document.querySelectorAll('.facetwp-facet[data-type="search"]').forEach(function (facet) {
        var input = facet.querySelector('input.facetwp-search');
        if (!input) return;
        var facetName = facet.getAttribute('data-name') || 'search';
        var inputId = 'facetwp-search-' + facetName;
        if (!input.id) input.id = inputId;
        // Cerca label associato: prima implicit (input.labels), poi explicit (for)
        var label = (input.labels && input.labels[0]) || document.querySelector('label[for="' + inputId + '"]');
        var labelText = label ? label.textContent.trim() : (input.placeholder || 'Cerca');
        input.setAttribute('aria-label', labelText);
    });
}

document.addEventListener('DOMContentLoaded', enhanceFacetWPAccessibility);
document.addEventListener('facetwp-loaded', enhanceFacetWPAccessibility);

// Funzione per scorrere la lista a sinistra
var scrollLeft = document.querySelector('.scroll-left');
if (scrollLeft) {
    scrollLeft.addEventListener('click', function() {
        const scrollWrapper = document.querySelector('.scroll-wrapper');
        if (scrollWrapper) {
            scrollWrapper.scrollBy({
                left: -200,
                behavior: 'smooth'
            });
        }
    });
}

// Funzione per scorrere la lista a destra
var scrollRight = document.querySelector('.scroll-right');
if (scrollRight) {
    scrollRight.addEventListener('click', function() {
        const scrollWrapper = document.querySelector('.scroll-wrapper');
        if (scrollWrapper) {
            scrollWrapper.scrollBy({
                left: 200,
                behavior: 'smooth'
            });
        }
    });
}

const cards = document.querySelectorAll('.card-archive');
Array.prototype.forEach.call(cards, card => {
    let down, up, link = card.querySelector('.card-archive__title-heading a');
    card.style.cursor = 'pointer';
    card.onmousedown = (e) => {
        // Verifica se è il tasto sinistro (0)
        if (e.button === 0) {
            down = +new Date();
        }
    }
    card.onmouseup = (e) => {
        // Procedi solo se è il tasto sinistro (0)
        if (e.button === 0) {
            up = +new Date();
            if ((up - down) < 200) {
                link.click();
            }
        }
    }
});
